// extracted by extract-css-chunks-webpack-plugin
module.exports = {"process-header":"landing-page__process-header___2ey9p","processHeader":"landing-page__process-header___2ey9p","btn-container":"landing-page__btn-container___23W-e","btnContainer":"landing-page__btn-container___23W-e"};
    if(module.hot) {
      // 1771211613865
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  